import {
  ChangeEvent, ReactElement, useEffect, useRef, useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '~/components';
import { InfoContainer } from '~/pages/Analysis/DAMs/styles';

interface VentilationFormValues {
  start: string;
  end: string;
}

interface DamVentilationFormProps {
  onChange: (ventilation: VentilationFormValues) => void;
  disabled?: boolean;
  onlyList?: boolean;
  defaultValues?: VentilationFormValues;
}

function verifyMaxNumber(event: ChangeEvent<HTMLInputElement>): boolean {
  const raw = event.target.value.replaceAll(/\D/g, '');
  const num = raw ? Number(raw) : 0;

  return num < 360;
}

export function DamVentilationForm({
  disabled,
  onChange,
  onlyList,
  defaultValues,
}: Readonly<DamVentilationFormProps>): ReactElement {
  const firstRender = useRef(false);
  const [ventilation, setVentilation] = useState<VentilationFormValues>(defaultValues ?? {
    start: '0',
    end: '0',
  });
  const { t } = useTranslation();

  function onChangeStart(event: ChangeEvent<HTMLInputElement>): void {
    const newStart = verifyMaxNumber(event) ? event.target.value : '360';
    const updated = { ...ventilation, start: newStart };
    setVentilation(updated);
    onChange(updated);
  }

  function onChangeEnd(event: ChangeEvent<HTMLInputElement>): void {
    const newEnd = verifyMaxNumber(event) ? event.target.value : '360';
    const updated = { ...ventilation, end: newEnd };
    setVentilation(updated);
    onChange(updated);
  }

  useEffect(() => {
    if (defaultValues && !firstRender.current) {
      firstRender.current = true;
      setVentilation(defaultValues);
    }
  }, [defaultValues]);

  return (
    <InfoContainer>
      <h4>{t('ventilacao')}</h4>
      {!onlyList && (<p>{t('habilitarTempoVentilacao')}</p>)}
      <div>
        <div>
          <Input
            label={t('inicio')}
            placeholder={t('inicio')}
            value={ventilation.start}
            onChange={onChangeStart}
            mask={[/\d/, /\d/, /\d/]}
            style={{ width: '80px', height: '50px' }}
            guide={false}
            max={360}
            disabled={disabled}
          />
          <span>{t('minutos').toLowerCase()}</span>
        </div>
        <div>
          <Input
            label={t('fim')}
            placeholder={t('fim')}
            value={ventilation.end}
            onChange={onChangeEnd}
            mask={[/\d/, /\d/, /\d/]}
            style={{ width: '80px', height: '50px' }}
            guide={false}
            disabled={disabled}
          />
          <span>{t('minutos').toLowerCase()}</span>
        </div>
      </div>

    </InfoContainer>
  );
}
